export default "__VITE_ASSET__CpTKVVY3__"